var _circle, _path, _g, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_866_257)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4688 53.1865C36.8637 52.0448 37.947 51.2778 39.1649 51.2778H60.5611C61.7631 51.2778 62.8358 52.0251 63.2428 53.1459L67.627 65.2192C68.2953 67.0597 66.9191 69.0001 64.9453 69.0001H34.9895C33.0341 69.0001 31.6594 67.093 32.2934 65.2598L36.4688 53.1865Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_866_257)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1976 47.2555L51.5612 61.9253C52.2747 63.2621 52.7861 64.3365 53.4995 62.9997L63.2764 47.2684C64.2718 45.5721 64.8418 43.6005 64.8418 41.4969C64.8418 35.1472 59.6478 29.9998 53.2408 29.9998C46.8337 29.9998 41.6398 35.1472 41.6398 41.4969C41.6398 43.2723 42.0458 44.9537 42.7709 46.4548L42.7767 46.4668C42.9069 46.7357 43.0474 46.9987 43.1976 47.2555Z",
    fill: "url(#paint1_linear_866_257)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1976 47.2555L51.5612 61.9253C52.2747 63.2621 52.7861 64.3365 53.4995 62.9997L63.2764 47.2684C64.2718 45.5721 64.8418 43.6005 64.8418 41.4969C64.8418 35.1472 59.6478 29.9998 53.2408 29.9998C46.8337 29.9998 41.6398 35.1472 41.6398 41.4969C41.6398 43.2723 42.0458 44.9537 42.7709 46.4548L42.7767 46.4668C42.9069 46.7357 43.0474 46.9987 43.1976 47.2555Z",
    stroke: "url(#paint2_linear_866_257)",
    strokeWidth: 0.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.2405,
    cy: 41.5409,
    rx: 4.35038,
    ry: 4.31143,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_866_257",
    x: 39.4896,
    y: 27.85,
    width: 27.5021,
    height: 37.9133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_866_257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_866_257",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_866_257",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_866_257",
    x1: 62.3589,
    y1: 60.5116,
    x2: 34.1984,
    y2: 50.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_866_257",
    x1: 51.3073,
    y1: 58.0106,
    x2: 35.7064,
    y2: 32.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneLocation);
export default __webpack_public_path__ + "static/media/milestone-location.8db377e64b629f988eaf6a8f3c864f5a.svg";
export { ForwardRef as ReactComponent };